export const MY_REWARDS = 'pfjMyRewardsNumber';
export const DRIVER_ID = 'driverId';
const FIRST_NAME = 'firstname';
const LAST_NAME = 'lastname';
const PHONE = 'phone';

export const mustLogWhenAdded = [
  DRIVER_ID, MY_REWARDS,
];

export const mustLogWhenEdited = [
  MY_REWARDS, FIRST_NAME, LAST_NAME, PHONE,
];
